import { axios } from '../plugins/AxiosPlugin';

export default function $axios() {
  return axios;
}
